<template>
    <div class="over-fooer-gq">
        <div class="footer-gq container"  :class="Pager.Config.ContainerClass">
            <div class="footer-left">
                <div class="img-list-a">
                    <ul class="clearfix">
                        <li><a target="_blank" href="http://www.eduyun.cn"><img src="/static/images/home/skin/zibogq/u955.png" alt="" class="support-img"></a></li>
                        <li><a target="_blank" href="http://yy.eduzibo.com"><img src="/static/images/home/skin/zibogq/u956.png" alt="" class="support-img other-img"></a></li>
                        <li><a target="_blank" href="http://www.sdei.edu.cn/wcms/wwwroot/sdedu/index.shtml"><img src="/static/images/home/skin/zibogq/u957.png" alt="" class="support-img"></a></li>
                        <li><a target="_blank" href="http://www.ziyuanku.com/"><img src="/static/images/home/skin/zibogq/china_resource.png" alt="" class="support-img"></a></li>
                        <li><a target="_blank" href="http://www.sdbern.cn/"><img src="/static/images/home/skin/zibogq/shandong_basics_teach.png" alt="" class="support-img"></a></li>
                        <li><a target="_blank" href="http://so.eduyun.cn/national/index"><img src="/static/images/home/skin/zibogq/country_basics_teach.png" alt="" class="support-img"></a></li>
                        <li><a target="_blank" href="http://www.ks750.com/"><img src="/static/images/home/skin/zibogq/reference_resource.jpeg" alt="" class="support-img"></a></li>
                    </ul>
                </div>
                <div class="main-host-com">
                    <span>主办单位：山东省高青县教育局&nbsp;&nbsp;&nbsp;</span>
                    <span>电话：0533-6973600&nbsp;&nbsp;&nbsp;</span>
                    <span>通讯地址：高青县青城路65号</span>
                </div>
                <div class="tech-support">
                    <span>技术支持：创而新（北京）教育科技有限公司&nbsp;&nbsp;&nbsp;</span>
                    <span>010 - 8255 1116/400 6506 812&nbsp;&nbsp;&nbsp;</span>
                    <!-- <a href="http://www23.53kf.com/webCompany.php?arg=9006274&style=5" class="in-line-cus" title="在线客服" target="_blank"><img src="/static/images/home/skin/zibogq/kf.png" alt="">在线客服</a> -->
                </div>
            </div>
            <div class="ba-gq clearfix">
                <a href="http://beian.miit.gov.cn" target="_blank">
                    <span style="color:#333;">京ICP备09087741号-16</span>
                </a>
            </div>
            <div class="bac-img">
                <img src="/static/images/home/skin/zibogq/footer.png" alt="">
            </div>
        </div>
    </div>
</template>
    
<script>
export default {
    props: ['Pager'],
    mounted() {
        this.$emit('onFooterMounted')
    }
}
</script>
    
<style lang="css" scoped>
.over-fooer-gq{
    width: 100%;
    background: white;
    border-top: 5px solid #f8f8f8!important;
    -webkit-box-shadow: 0 -2px 8px #ccc;
    box-shadow: 0 -2px 8px #ccc;
}
.footer-gq{
    height: 293px;
    position: relative;
}
.ba-gq{
    position: absolute;
    width: 100%;
    height: 30px;
    text-align: center;
    bottom: 38px;
    left: 0;
}

.footer-left{
    width: 56%;
    float: left;
}
.img-list-a li{
    float: left;
    margin-top: 15px;
    text-align: left;
    list-style: none;
    margin-right: 2%;
}
.img-list-a .support-img{
    display: block;
    height: 28px;
}

.main-host-com, .tech-support{
    text-align: left;
}
.other-img{
    width: 200px;
}
.main-host-com{
    margin-top: 20px;
}
.in-line-cus{
    color: #29BD9B;
}
.in-line-cus img{
    margin-right: 7px;
}
.tech-support{
    margin-top: 15px;
}
.bac-img{
    margin-top: 80px;
    float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/common/site/FooterZiboGq.vue